import axios from "../customize_axios"

export const getAllBanner = async (token, page) => {
    try {
        const response = await axios.get(
            `api/banners?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAllBanner", error.response ? error.response.data : error.message)
        return []
    }
}

export const addBanner = async (token, formData) => {
    try {
        const response = await axios.post(
            "api/banners", 
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response
    } 
    catch (error) {
        console.log("addBanner: ",  error.response ? error.response.data : error.message)
    }
}

export const updateBanner = async (token, id, formData) => {
    try {
        const response = await axios.put(
            `api/banners/${id}`, 
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response
    } 
    catch (error) {
        console.log("updateBanner: ",  error.response ? error.response.data : error.message)
    }
}

export const hideBanner = async (token, id) => {
    try {
        const response = await axios.post(
            `api/banners/hide/${id}`, 
            {},
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response
    } 
    catch (error) {
        console.log("hideBanner: ",  error.response ? error.response.data : error.message)
    }
}

export const unhideBanner = async (token, id) => {
    try {
        const response = await axios.post(
            `api/banners/unhide/${id}`, 
            {},
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response
    } 
    catch (error) {
        console.log("unhideBanner: ",  error.response ? error.response.data : error.message)
    }
}

export const deleteBanner = async (token, id) => {
    try {
        const response = await axios.delete(
            `api/banners/${id}`,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response
    } 
    catch (error) {
        console.log("deleteBanner: ",  error.response ? error.response.data : error.message)
    }
}